import Login from "../models/security/LoginRequest";
import LoginResponse from "../models/security/LoginResponse";

export default class AuthenticationService {

  static async call(login: Login): Promise<LoginResponse | undefined> {
    const response = await fetch("https://mariospizzas.tsao-tsao.com:58443/auth/signin", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(login),
    });

    if (response.ok) {
      return await response.json();
    }
  }

  static async login(username: string, password: string): Promise<boolean> {
    console.log(JSON.stringify({ username, password }));
    await this.call(new Login(username, password)).then((response) => {
      if (response !== undefined) {
        localStorage.setItem("jwt", response.jwt);
        localStorage.setItem("expiration", response.expiration);
        localStorage.setItem("refreshToken", response.refreshToken);
        localStorage.setItem("user", JSON.stringify(response.user));
      }
    });
    console.log(JSON.stringify({ username, password }));

    return new Promise((resolve) => resolve(this.isAuthenticated()));
  }

  static logout(): void {
    localStorage.removeItem("jwt");
    localStorage.removeItem("expiration");
    localStorage.removeItem("user");
    localStorage.removeItem("refreshToken");
    //    console.log("est-ce que je passe dans logout ?");
    //    console.log(localStorage);
    // window.location.reload();
  }

  static isAuthenticated(): boolean {
    if (localStorage.getItem("jwt") !== null) {
      const expiration = localStorage.getItem("expiration");

      //    console.log("combien", expiration, expiration !== null && Date.parse(expiration), Date.now());

      return expiration !== null && Date.parse(expiration) > Date.now();
    } else {
      return false;
    }
  }

  static getJwt(): any {
    return localStorage.getItem("jwt");
  }

  static getUser(): any {
    return localStorage.getItem("user");
  }
}
